module.exports = __webpack_public_path__ + "img/case-mfzhb.42512cc2.png";